import isFunction from 'lodash/isFunction'
import isObject from 'lodash/isObject'
import deepClone from 'lodash/cloneDeep'

import * as setAnimateConfig from './setAnimateConfig'
import * as setAxisConfig from './setAxisConfig'
import * as setCoordConfig from './setCoordConfig'
import * as setDataConfig from './setDataConfig'
import * as setGuideConfig from './setGuideConfig'
import * as setLegendConfig from './setLegendConfig'
import * as setSeriesConfig from './setSeriesConfig'
import * as setTooltipConfig from './setTooltipConfig'
import * as setPieLabelConfig from './setPieLabelConfig'

const wrapper = ({ process, key }) => {
  const wrapperProcess = (chart, wholeConfig) => {
    const config = deepClone(key ? wholeConfig[key] : wholeConfig)

    let beforeHook
    let afterHook

    if (isObject(config)) {
      beforeHook = config.beforeProcess
      afterHook = config.processed
      Reflect.deleteProperty(config, 'beforeProcess')
      Reflect.deleteProperty(config, 'processed')
    }

    if (isFunction(beforeHook)) {
      beforeHook(chart, config, wholeConfig)
    }

    process(chart, config)

    if (isFunction(afterHook)) {
      afterHook(chart, config, wholeConfig)
    }
  }

  return {
    process: wrapperProcess,
  }
}

export default {
  setLegendConfig: wrapper(setLegendConfig),
  setTooltipConfig: wrapper(setTooltipConfig),
  setSeriesConfig: wrapper(setSeriesConfig),
  setGuideConfig: wrapper(setGuideConfig),
  setDataConfig: wrapper(setDataConfig),
  setCoordConfig: wrapper(setCoordConfig),
  setAxisConfig: wrapper(setAxisConfig),
  setAnimateConfig: wrapper(setAnimateConfig),
  setPieLabelConfig: wrapper(setPieLabelConfig),
}
